"use client";

import { useState } from "react";

interface CodeTab {
  label: string;
  code: string;
}

interface Props {
  tabs: CodeTab[];
}

/** Tabbed multi-language code sample — e.g. the same request shown as curl, JS, and Python. */
export default function CodeGroup({ tabs }: Props) {
  const [active, setActive] = useState(0);

  return (
    <div className="my-6 overflow-hidden rounded-xl border border-border-subtle bg-bg-elevated">
      <div role="tablist" className="flex gap-1 border-b border-border-subtle px-2 pt-2">
        {tabs.map((tab, i) => (
          <button
            key={tab.label}
            type="button"
            role="tab"
            aria-selected={active === i}
            onClick={() => setActive(i)}
            className={`cursor-pointer rounded-t-md px-3 py-1.5 font-mono text-[12px] transition-colors ${
              active === i
                ? "bg-bg-card text-brand-purple-light"
                : "text-text-muted hover:text-text-secondary"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <pre className="overflow-x-auto p-5">
        <code className="font-mono text-[12.5px] leading-relaxed text-text-secondary">
          {tabs[active].code}
        </code>
      </pre>
    </div>
  );
}
